import { ReactNode } from 'react';
import { Content } from 'src/contexts/ContentContext';
import { Stack } from 'src/core/ui';
import { ContentId } from 'src/utils/constants/contentId';

import * as styles from './OnSaleEventDetails.css';

export const OnSaleEventDetailsHeader = ({
  titleContentId,
  titlePostContent,
  rightContent,
}: {
  titleContentId: ContentId;
  titlePostContent?: ReactNode;
  rightContent?: ReactNode;
}) => {
  return (
    <Stack
      alignItems="center"
      width="full"
      justifyContent="spaceBetween"
      className={styles.onSaleEventDetailsHeader}
    >
      <Stack direction="row" gap="s" alignItems="center">
        <Content id={titleContentId} />
        {titlePostContent}
      </Stack>
      <div>{rightContent}</div>
    </Stack>
  );
};
